import { computed } from "vue";
import { useResultElements } from "#ce/components/SpFinder/composables/useResultElements";
import { useResultEvents } from "#ce/components/SpFinder/composables/useResultEvents";

/**
 * Returns the sidebar's result cards and their wiring: card events run the finder's commands, and
 * hovering a card emits `highlight` / `unhighlight` with its result GUID.
 */
export function useFinderMapSidebar(props, emit, container) {
  const empty = computed(() => props.payload?.result_count === 0);
  const cards = useResultElements(
    () => props.records ?? [],
    () => props.kind,
    () => ({ payload: props.payload, settings: props.settings }),
  );
  function cardModifiers(record) {
    return { "--selected": Boolean(props.selectedGuid) && record.resultGUID === props.selectedGuid };
  }
  function highlight(guid) {
    emit("highlight", guid);
  }
  function unhighlight(guid) {
    emit("unhighlight", guid);
  }
  useResultEvents(container, () => props.commands);
  return { empty, cards, cardModifiers, highlight, unhighlight };
}
